import React from "react";
import Loader from "../../Loader";
import { formStyles } from "../formStyles";

export default function ReporterDetailsStep(props) {
  const { register, inputs, handleChange, handleSubmit, onSubmitReporter, isLoading, profileType, states, lgs, setStep } = props;

  return (
    <div className={formStyles.card}>
      <h2 className={formStyles.header}>Reporter Details</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
        <div>
          <label className={formStyles.label}>
            {profileType === "individual" ? "First Name" : "Organization Name"}
          </label>
          <input 
            type="text" 
            value={inputs.r_first_name || ""}
            {...register("r_first_name", { required: true, onChange: handleChange })} 
            className={`${formStyles.input} uppercase`} 
          />
        </div>
        
        {profileType === "individual" && (
          <div>
            <label className={formStyles.label}>Middle Name</label>
            <input 
              type="text" 
              value={inputs.r_middle_name || ""}
              {...register("r_middle_name", { onChange: handleChange })} 
              className={`${formStyles.input} uppercase`} 
            />
          </div>
        )}
        
        {profileType === "individual" && (
          <div>
            <label className={formStyles.label}>Last Name</label>
            <input 
              type="text" 
              value={inputs.r_last_name || ""}
              {...register("r_last_name", { required: true, onChange: handleChange })} 
              className={`${formStyles.input} uppercase`} 
            />
          </div>
        )}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
        {profileType === "individual" && (
          <div>
            <label className={formStyles.label}>Gender</label>
            <select 
              value={inputs.r_gender || ""}
              {...register("r_gender", { required: true, onChange: handleChange })} 
              className={formStyles.input}
            >
              <option value="">Select Gender</option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
            </select>
          </div>
        )}
        
        <div>
          <label className={formStyles.label}>Phone Number</label>
          <input 
            type="text" 
            value={inputs.r_phone || ""}
            {...register("r_phone", { required: true, onChange: handleChange })} 
            className={formStyles.input} 
          />
        </div>
        
        <div>
          <label className={formStyles.label}>Email Address</label>
          <input 
            type="email" 
            value={inputs.r_email || ""}
            {...register("r_email", { required: true, onChange: handleChange })} 
            className={formStyles.input} 
          />
        </div>
      </div>

      <div className="mb-6">
        <label className={formStyles.label}>Residential Address</label>
        <input 
          type="text" 
          value={inputs.r_address || ""}
          {...register("r_address", { required: true, minLength: 10, onChange: handleChange })} 
          className={formStyles.input} 
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label className={formStyles.label}>Current State of Residence</label>
          <select 
            value={inputs.r_state || ""}
            {...register("r_state", { required: true, onChange: handleChange })} 
            className={formStyles.input}
          >
            <option value="">Select State</option>
            {states.map((val, idx) => <option key={idx} value={val}>{val}</option>)}
          </select>
        </div>
        
        <div>
          <label className={formStyles.label}>Current LGA</label>
          <select 
            value={inputs.r_lga || ""}
            {...register("r_lga", { required: true, onChange: handleChange })} 
            className={formStyles.input}
          >
            <option value="">Select LGA</option>
            {lgs.map((val, idx) => <option key={idx} value={val}>{val}</option>)}
          </select>
        </div>
      </div>

      <div className="flex justify-between items-center mt-10 pt-6 border-t border-gray-200">
        <button type="button" onClick={() => setStep(1)} className={formStyles.buttonSecondary}>&laquo; Previous</button>
        <button type="button" onClick={handleSubmit(onSubmitReporter)} className={formStyles.buttonPrimary}>
          Next &raquo; {isLoading && <span className="ml-2"><Loader /></span>}
        </button>
      </div>
    </div>
  );
}